import { render } from "./OwnedOrNot.vue?vue&type=template&id=dab78d8e&scoped=true"
import script from "./OwnedOrNot.vue?vue&type=script&lang=js"
export * from "./OwnedOrNot.vue?vue&type=script&lang=js"

import "./OwnedOrNot.vue?vue&type=style&index=0&id=dab78d8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dab78d8e"]])

export default __exports__